import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLenis, ScrollToTop } from "@/components/Smooth";

export default function Layout() {
  useLenis();
  return (
    <div className="relative min-h-screen overflow-hidden" style={{ background: "#ececef" }}>
      <div className="aurora"><span className="a1" /><span className="a2" /><span className="a3" /><span className="a4" /></div>
      <ScrollToTop />
      <Navbar />
      <main className="relative z-[2]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
